export default __webpack_public_path__ + "static/media/goalPageDark.0ce6a3eb.png";